import axios from 'axios';

const initializeTrackers = async () => {
  var ValidSub;
  const { data } = await axios.get(process.env.REACT_APP_BASE_URL + 'profile');
  const subscriptionFetch = await axios.get(
    process.env.REACT_APP_BASE_URL + 'subscription/details',
  );

  const subDetails = subscriptionFetch.data.subscriptionDTOs;
  if (subDetails && subDetails.length) {
    var { planType, productType } = subDetails[0];
  }
  (() => {
    let subscribedProduct =
      subDetails && subDetails.filter((item) => item.subscriptionStatus !== 'ACTIVE');
    let check =
      subscribedProduct &&
      subscribedProduct[0]?.endDate &&
      new Date(subscribedProduct[0].endDate).getTime() > new Date().getTime();

    if (subscriptionFetch.data.subscribedUser) {
      ValidSub = true;
      return true;
    } else if (!subscriptionFetch.data.hasEverPurchased) {
      ValidSub = false;
      return false;
    }

    /**** TO BE UNCOMMENTED IF END DATE IS KEPT IN CONSIDERATION ****/
    ValidSub = check;
    return check;
  })();

  const env = process.env.NODE_ENV;
  let options = { ...data, env, planType, productType, ValidSub };

  initializePendo(options);
  initializeAmplitude(options);
};

const initializePendo = (options) => {
  const { email, name, company, env, planType, productType, ValidSub } = options;
  if (pendo) {
    pendo.initialize({
      visitor: {
        id: email,
        email: email,
        username: name,
        environment: env,
      },
      account: {
        id: company || 'Not Created',
        rebidConsole: 'Subscribed',
        environment: env,
        rebidBuy:
          productType === 'BUY'
            ? ValidSub
              ? planType === 'FT'
                ? 'Free trial'
                : `Subscribed | ${planType}`
              : 'Unsubscribed'
            : 'Unsubscribed',
        rebidDesk: productType === 'DESK' ? planType + '@' + productType : 'Unsubscribed',
        creationDate: new Date().toLocaleString(),
      },
    });
  }
};

const initializeAmplitude = (options) => {
  const { email, name, company, env } = options;
  // Amplitude Initialization
  if (window.amplitude) {
    const amplitudeClient = amplitude.getInstance();
    amplitudeClient.setUserId(email);
    amplitudeClient.setGroup(company);
    amplitudeClient.setUserProperties({
      Username: name,
      Environment: env,
      Package: '',
    });
  }
};

const _track = (eventname, data) => {
  if (window.pendo) {
    pendo.track(eventname, data);
  }
  if (window.amplitude) {
    amplitude.getInstance().logEvent(eventname, data);
  }
};

export { initializeTrackers, _track };
